/**
 * Format a duration in minutes to a human-readable string.
 *
 * - Under 60 min → "45 min"
 * - 60+ min      → "1h 30m"
 * - Rounds to the nearest 5 minutes.
 *
 * @param {number|string} minutes — raw minutes (accepts string for convenience)
 * @returns {string|null} formatted string, or null if input is falsy/invalid
 */
export default function formatDuration(minutes) {
  const m = Math.round(Number(minutes));
  if (!m || isNaN(m) || m <= 0) return null;

  // Round to nearest 5
  const rounded = Math.round(m / 5) * 5 || 5; // minimum 5

  if (rounded < 60) return `${rounded} min`;

  const h = Math.floor(rounded / 60);
  const rem = rounded % 60;
  return rem > 0 ? `${h}h ${rem}m` : `${h}h`;
}
